import './index.css'
import cn from 'clsx'
import * as React from 'react'
type props = {
  checked: boolean
  onToggle: (...args: Array<any>) => any
  children?: React.ReactNode
}

/**
 * @deprecated Use `Switch` from `components/ds` instead.
 * @see {@link components/ds/Switch}
 * @migration
 * - Replace with `Switch` from components/ds:
 *   - checked → checked (same)
 *   - onToggle → onCheckedChange
 *   - children (caption) → Place `<Text>` next to Switch, or use `<Text as="label">`
 * - Example:
 *   ```tsx
 *   // Legacy
 *   <Toggle checked={enabled} onToggle={setEnabled}>
 *     Enable notifications
 *   </Toggle>
 *
 *   // DS alternative
 *   import { Switch, Text } from 'components/ds'
 *
 *   <Text as="label" size="2">
 *     <Flex gap="2">
 *       <Switch checked={enabled} onCheckedChange={setEnabled} />
 *       Enable notifications
 *     </Flex>
 *   </Text>
 *   ```
 *
 * A toggle component that provides a switch interface with optional caption
 * @param checked - Whether the toggle is currently checked
 * @param onToggle - Callback called when the toggle state changes
 * @param children - Optional caption content displayed next to the toggle
 * @returns A toggle switch with optional caption
 */
const Toggle = ({
  checked,
  onToggle,
  children,
}: props): React.ReactElement<'div'> => (
  <div className="ToggleContainer">
    <div
      className={cn('Toggle', {
        'Toggle--Checked': checked,
      })}
      onClick={onToggle}
    >
      <div className="Toggle_Knob" />
    </div>
    <div className="Toggle_Caption">{children}</div>
  </div>
)

export default Toggle
